<ng-template #content let-modal>
  <div class="modal-header title-modal-personalized">
    <h2 class="c-form__titulo h1-montserrat text-white">
      {{ modalConfig.modalTitle }}
    </h2>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>

  <div class="d-flex justify-content-center align-content-center mb-2">
    <div
      class="col-3 p-1"
      *ngIf="
        modalConfig.hideDismissButton === undefined ||
        !modalConfig.hideDismissButton
      ">
      <button
        type="button"
        class="btn btn-primario"
        (click)="dismiss()"
        [disabled]="
          modalConfig.disableDismissButton !== undefined &&
          modalConfig.disableDismissButton()
        ">
        <span>
          {{ modalConfig.dismissButtonLabel ?? "Aceptar" }}
        </span>
      </button>
    </div>
    <div
      class="col-3 mx-1 p-1"
      *ngIf="
        modalConfig.hideCloseButton === undefined ||
        !modalConfig.hideCloseButton
      ">
      <button
        type="button"
        class="btn btn-secondary-cap"
        (click)="close()"
        [disabled]="
          modalConfig.disableCloseButton !== undefined &&
          modalConfig.disableCloseButton()
        ">
        <span>
          {{ modalConfig.closeButtonLabel ?? "Cerrar" }}
        </span>
      </button>
    </div>
  </div>
</ng-template>
